// 统一请求路径前缀在libs/axios.js中修改
import {
  doPostRequest,
  postDataRequest,
  getusrdataRequest,
  saveusrDataRequest,
  getRequest2,
  getphoneRequest,
  deletePRequest,
  deleteMideaRequest,
  getRequest4,
  getRequest3,
  showmideaRequest,
  saveDataRequest_audit,
  showDataRequest,
  saveDataRequest,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  importRequest,
  uploadFileRequest,
  postRequestpdfORimg,
  getDataRequest,
  getRequestpdfORimg,
} from '@/utils/axios';
export const getFindListParent = params => {
  return getRequest('/es/testPage', params);
};

export const findRegulationsPage = params => {
  return getRequest('/regulations/findRegulationsPage', params);
};

export const getscenicRating = params => {
  return getRequest('/tourismInfo/scenicRating', params);
};

export const findListZoningAndChildren = params => {
  return getRequest('/zoning/findListZoningAndChildren', params);
};

export const resourceMap = params => {
  return getRequest('/tourismInfo/resourceMap', params);
};

// 政策文件下载
export const downLoadBatch = params => {
  return postRequestpdfORimg('/regulations/downLoadBatch/' + params);
};

// 政策文件详情下载
export const downLoad = params => {
  return postRequestpdfORimg('/common/downLoad', params);
};

// 政策文件详情
export const findRegulationsById = params => {
  return getRequest('/regulations/findRegulationsById', params);
};

// 通知公告
export const findNoticeListPage = params => {
  return getRequest('/notice/findNoticeListPage', params);
};
// 通知公告详情
export const findNoticeById = params => {
  return getRequest('/notice/findNoticeById/' + params);
};

// 培训学习
export const findTrainLearningListPage = params => {
  return getRequest('/trainLearning/findTrainLearningListPage', params);
};
// 培训学习详情
export const findTrainLearningById = params => {
  return getRequest('/trainLearning/findTrainLearningById/' + params);
};

// 首页详情
export const findHomePage = params => {
  return getRequest('/tourismInfo/homePage', params);
};

// 首页详情
export const findRealisticById = params => {
  return getRequest('/realistic/findRealisticById', params);
};

// 首页详情
export const findTourismInfoById = params => {
  return getRequest('/tourismInfo/findTourismInfoById', params);
};

// 首页资源概括
export const getTypeStatisticsCompleted = params => {
  return getRequest('/tourismInfo/getTypeStatisticsCompleted', params);
};

// 首页资源
export const recommendedAttractions = params => {
  return getRequest('/tourismInfo/recommendedAttractions', params);
};

// 首页-资源排行
export const resourceAccessRanking = () => {
  return getRequest('/tourismInfo/resourceAccessRanking');
};

// 首页-新发现资料数据
export const newResources = () => {
  return getRequest('/tourismInfo/newResources');
};

// 优质资源 查询
export const getRecommendation = params => {
  return getRequest('/tourismInfo/getRecommendation', params);
};

// 优质资源 查询
export const addPageView = params => {
  return getRequest('/tourismInfo/view', params);
};

// 平台介绍/zituSpace/home/operationHomeResourceStatistics
export const operationHomeResourceStatistics = params => {
  return getRequest('/home/operationHomeResourceStatistics', params);
};
// 资源概况zituSpace/tourismInfo/trendStatistics
export const trendStatistics = params => {
  return getRequest('/tourismInfo/trendStatistics', params);
};

// 资源分布/zituSpace/tourismInfo/scenicRating
export const scenicRating = params => {
  return getRequest('/tourismInfo/scenicRating', params);
};

// /zituSpace/realistic/findRealisticPage  实景三维    get请求  参数   pageNumber   pageNumber   type=liveAction3D

export const findRealisticPage = params => {
  return getRequest('/realistic/findRealisticPage', params);
};
// /zituSpace/video/findResourceVideoListPage   资源视频   get请求  参数  pageNumber   pageNumber
export const findResourceVideoListPage = params => {
  return getRequest('/video/findResourceVideoListPage', params);
};

// /zituSpace/minio/downloadFile  下载文件  get请求  参数bucket   objectName postRequestpdfORimg
export const downloadFile = params => {
  return getRequestpdfORimg('/minio/downloadFile', params);
};

export const findAndVisitsAdd = params => {
  return getRequest('/censusProducts/findAndVisitsAdd/' + params);
};

// http://192.168.1.29:4523/zituSpace/notice/findNoticeListPage   通知公告
export const getNoticeList = (params) => {
  return getRequest("/notice/findNoticeListPage", params);
};
export const getNoticeListByTitle = (params) => {
  return getRequest("/notice/findNoticeListByTitle", params);
};
// http://192.168.1.29:4523/zituSpace/trainLearning/findTrainLearningListPage  培训学习



// WEBPACK FOOTER //
// ./src/api/Recommended.js